export const RECORDING_TYPE_AI_CALL = 'ai-call';
export const RECORDING_TYPE_CALL = 'call';
export const RECORDING_TYPE_VOICE_MAIL = 'voice_mail';
export const RECORDING_TYPE_HANGED_UP = 'hanged_up';
export const RECORDING_TYPE_APPOINTMENT_CONFIRMATION =
    'appointment_confirmation';
export const RECORDING_TYPE_DISINTERESTED_CUSTOMER = 'disinterested_customer';

export const RECORDING_TYPE_TYPES = [
    RECORDING_TYPE_AI_CALL,
    RECORDING_TYPE_CALL,
    RECORDING_TYPE_VOICE_MAIL,
    RECORDING_TYPE_HANGED_UP,
    RECORDING_TYPE_APPOINTMENT_CONFIRMATION,
    RECORDING_TYPE_DISINTERESTED_CUSTOMER,
];
